import { ResponseCatalog, RequestParams } from 'Models'
import { StatusActModel } from 'Pages/acts'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Callback } from 'Src/types/utilTypes'

type ActStatusesState = {
	requestParams: RequestParams
	actStatusesSelect: ResponseCatalog<StatusActModel>
}

const ActStatusesInitialState: ActStatusesState = {
	requestParams: new RequestParams(),
	actStatusesSelect: new ResponseCatalog<StatusActModel>(),
}

export namespace actStatusesNS {
	export type setActStatusesRequestParams = PayloadAction<RequestParams>
	export type setActStatusesSelect = PayloadAction<ResponseCatalog<StatusActModel>>
	export type clearActStatusesSelect = PayloadAction
	export type getActStatusesSelect = PayloadAction<RequestParams>
	export type patchActUpdataStatus = PayloadAction<{
		arrId: number[]
		status_slug: string
		callback?: Callback
	}>
}

export const actStatusesSlice = createSlice({
	name: 'actStatuses',
	initialState: ActStatusesInitialState,
	reducers: {
		setActStatusesRequestParams: (state, action: actStatusesNS.setActStatusesRequestParams) => {
			state.requestParams = action.payload
		},
		setActStatusesSelect: (state, action: actStatusesNS.setActStatusesSelect) => {
			state.actStatusesSelect = action.payload
		},
		clearActStatusesSelect: (state, action: actStatusesNS.clearActStatusesSelect) => {
			return { ...state, actStatusesSelect: new ResponseCatalog<StatusActModel>() }
		},
		getActStatusesSelect: (state, action: actStatusesNS.getActStatusesSelect) => {},
		patchActUpdataStatus: (state, action: actStatusesNS.patchActUpdataStatus) => {},
	},
})
